import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { ModulosProvider } from './modulosContext';
import { UserProvider } from './userContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <UserProvider>
      <ModulosProvider>
        <App />
      </ModulosProvider>
    </UserProvider>
  </HashRouter>
);

reportWebVitals();
